import React, { useState } from "react";
import Logo_1 from "../assets/Logo_1.png";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Image,
  Button,
  Form,
  FloatingLabel,
} from "react-bootstrap";
import {
  AiFillHome,
  AiFillPhone,
  AiFillMail,
  AiOutlineUser,
  AiFillFacebook,
  AiFillInstagram,
} from "react-icons/ai";

import "./css/Footer.css";

import Insta from "../assets/Image 1.png";
import Tiet from "../assets/tiet.png";

const Footer = () => {
  const [message, setMessage] = useState("");

  const handleMail = (e) => {
    e.preventDefault();
    window.location.href = `mailto:adventureclub@thapar.edu?subject=Subject&body=${message}`;
  };
  return (
    <div id="footer">
      <Container
        fluid
        className="footer-section"
        style={{ marginTop: "100px" }}
      >
        <Row
          className="justify-content-md-center"
          style={{ marginTop: "20px" }}
        >
          <Col lg="6">
            <h1 style={{ fontFamily: "Bebas Neue" }}>
              Lets talk about everything!
            </h1>
            <p style={{ fontFamily: "Poppins" }}>
              Hate forms? Send us an email at <u>adventureclub@thapar.edu</u>{" "}
              instead.
            </p>
            <Image width="350px" src={Logo_1}></Image>
          </Col>
          <Col lg="6">
            <Form>
              <Form.Floating className="mt-5">
                <Form.Control id="name" type="text" placeholder="Name" />
                <label style={{ color: "black" }} htmlFor="floatingInputCustom">
                  <AiOutlineUser /> Name
                </label>
              </Form.Floating>
              <Form.Floating className="mt-5">
                <Form.Control
                  id="mail"
                  type="email"
                  placeholder="name@example.com"
                />
                <label style={{ color: "black" }} htmlFor="floatingInputCustom">
                  <AiFillMail /> Email address
                </label>
              </Form.Floating>
              <Form.Group id="message" className="mt-5">
                <Form.Control
                  as="textarea"
                  rows={3}
                  label="Message"
                  placeholder="   Your message goes here..."
                  onChange={(e) => setMessage(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Button
                variant="primary"
                type="submit"
                onClick={handleMail}
                className="mt-5"
              >
                <span>Send message</span>
              </Button>
            </Form>
          </Col>
        </Row>
        <Row
          className="justify-content-md-center"
          style={{ marginTop: "20px" }}
        >
          <Col lg="6">
            <h3 style={{ fontFamily: "Bebas Neue" }}>ADDRESS</h3>
            <p style={{ padding: "0% 20%", fontFamily: "Poppins" }}>
              Thapar University, P.O. Box 32, Bhadson Road, Patiala, Punjab, Pin
              -147004, India
            </p>
          </Col>
          <Col lg="6">
            <h3 style={{ fontFamily: "Bebas Neue" }}>STAY CONNECTED</h3>

            <h1>
              <a href="https://www.instagram.com/thaparadventureclub/">
                {" "}
                <AiFillInstagram style={{ margin: "2%" }} />
              </a>
              <a href="https://www.facebook.com/ThaparAdventureClub/">
                {" "}
                <AiFillFacebook style={{ margin: "2%" }} />
              </a>
            </h1>
          </Col>
        </Row>
        <div>
          <a className="techTeam" href="/TechTeam">
            <h4>Made with ❤️ by Tech Team</h4>
          </a>
        </div>
      </Container>
    </div>
  );
};
export default Footer;
